export enum SubscriptionStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  InTrial = 'In_Trial',
  PaymentDue = 'Payment_Due',
  ScheduledForCancellation = 'Scheduled_For_Cancellation',
}
